var YMK = YMK || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.standaloneYoucamV1 = {
    attach: function (context, settings) {
      var $standaloneYoucam = $('.js-standalone-youcam-v1', context);
      var youcamAPIKey = $standaloneYoucam.attr('data-api-key');
      var youcamAPIUrl = $standaloneYoucam.attr('data-api-url');

      if (!youcamAPIKey) {
        return;
      }
      var youcamEvents = [
        'cameraClosed',
        'cameraFailed',
        'cameraOpened',
        'compare',
        'compareDisabled',
        'closed',
        'engineClosed',
        'loaded',
        'loading',
        'kissDetected',
        'opened',
        'photoLoaded',
        'photoSaved',
        'reset',
        'videoLoaded',
        'shadeFinderStarted',
        'shadeFinderComplete',
        'shadeFinderCancelled',
        'zoom'
      ];
      var $siteHeader = $('.js-site-header', context);
      var $siteFooterSticky = $('.js-footer-sticky', context);
      var bannerHeight = $siteHeader.height() + $siteFooterSticky.height();
      var extraViewportMargin = 0;
      var maxAllowedHeight = 766;
      var iframeMinHeight = 454;
      var iframeHeight = '';
      var vtoLanguage = settings.vto_language;
      var isCaFr = document.location.hostname.search('fr.aveda.ca') >= 0;

      // Iframe height fix for Youcam
      if (Unison.fetch.now().name === 'small') {
        extraViewportMargin = 70;
      }
      if (Unison.fetch.now().name === 'landscape') {
        extraViewportMargin = window.innerWidth <= 1024 ? 90 : 0;
      }
      if (Unison.fetch.now().name === 'portrait') {
        extraViewportMargin = 140;
      }
      iframeHeight = window.innerHeight - bannerHeight - extraViewportMargin;
      iframeHeight = iframeHeight < iframeMinHeight ? iframeMinHeight : iframeHeight;
      iframeHeight = iframeHeight > maxAllowedHeight ? maxAllowedHeight : iframeHeight;

      (function (d, k) {
        var s = d.createElement('script');

        s.type = 'text/javascript';
        s.async = true;
        s.src = youcamAPIUrl + k;
        var x = d.getElementsByTagName('script')[0];

        x.parentNode.insertBefore(s, x);
      })(document, youcamAPIKey);

      window.ymkAsyncInit = function () {
        var vtoParams = {
          autoOpen: true,
          height: iframeHeight,
          disable2ColorComparison: true,
          enableFBSharing: true,
          enableEmailSharing: true
        };

        if (isCaFr) {
          vtoParams['language'] = settings.vto_language_fr;
        } else if (vtoLanguage) {
          vtoParams['language'] = vtoLanguage;
        }

        window.YMK.init(vtoParams);
        youcamEvents.forEach(function (event) {
          window.YMK.addEventListener(event, function () {
            site.track.evtLink({
              event_name: 'YouCam',
              event_category: 'YouCam',
              event_action: event,
              event_label: 'event'
            });
          });
        });
      };
    }
  };
})(jQuery);
